import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron-down",
  "use": "chevron-down-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"chevron-down\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.354 10.854a.5.5 0 0 1-.708 0l-5-5a.5.5 0 1 1 .708-.708L8 9.793l4.646-4.647a.5.5 0 0 1 .708.708l-5 5Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol